// extracted by mini-css-extract-plugin
export var acceptButton = "_12-5";
export var fullContent = "_12-4";
export var link = "_12-6";
export var linkIcon = "_12-7";
export var sideContent = "_12-3";
export var sideImage = "_12-2";
export var sideImageWrapper = "_12-1";
export var splitLayout = "_12-0";